export default __webpack_public_path__ + "static/media/close_button_share_page.8283c418.svg";